// Model.js
// -----------------------
// @module Case
define("SuiteDB.SDBYMM.SDBYMM.SS2Model", ["Backbone", "Utils"], function (
  Backbone,
  Utils
) {
  "use strict";

  // @class Case.Fields.Model @extends Backbone.Model
  return Backbone.Model.extend({
    //@property {String} urlRoot
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath("Modules/SDBYMM/SuiteScript2/SDBYMM.Service.ss"),
      true
    ),
  });
});
